<div class="title-emphasis">
  <img [src]="imageUtil.getGenderImage(selectedClient?.person?.genderCd)" class="title-ico" alt="Gender Icon">
  <div>
    <h4 class="p-0 m-0">{{commonUtilty.NVL(selectedClient?.person?.firstName)}}
      {{commonUtilty.NVL(selectedClient?.person?.lastName)}}
      <i nz-icon *ngIf="selectedClient?.blackListedFl" style="color: rgba(255, 0, 0, 0.818); font-size: larger;"
        nzType="info-circle" nz-tooltip nzTooltipTitle="Client is Blacklisted" nzTheme="outline"></i>
    </h4>
    <span class="col-grey-dark">
      {{ selectedClient?.dob }}
      ({{selectedClient?.age}})
    </span>
    <div class="col-grey-dark">
      {{ (commonUtilty.NVL(selectedClient?.person?.genderCd) | technicalTranslate: 'genderCd')}}
    </div>
  </div>
</div>

<div class="summary-container">
  <div>
    <span class="s-c-head">Client Number</span>
    {{ commonUtilty.NVL(selectedClient?.clientNum) }}
  </div>

  <div>
    <span class="s-c-head">Marital Status</span>
    {{ commonUtilty.NVL(selectedClient?.person?.maritalStatusCd) | technicalTranslate : 'maritalStatusCd' }}
  </div>

  <div>
    <span class="s-c-head">Country of Birth</span>
    {{ commonUtilty.NVL(selectedClient?.person?.countryOfBirthCd) | technicalTranslate : 'countryCd' }}
  </div>

  <div>
    <span class="s-c-head">Citizenship</span>
    {{ commonUtilty.NVL(selectedClient?.citizenshipCd) | technicalTranslate: 'citizenshipCd' }}
  </div>
</div>

<!-- Occupation Details -->
<ng-container>
  <h3 class="heading heading-summary">Occupation</h3>
  <nz-table *ngIf="commonUtilty.hasDetails(selectedClient?.person?.personEmployments)" #smallTable nzSize="small" #OccupationTable [nzData]="selectedClient?.person?.personEmployments"
    [nzShowPagination]="false" [nzBordered]="true">
    <thead>
      <tr>
        <th>Occupation</th>
        <th>Annual Income</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of OccupationTable.data">
        <td>{{ commonUtilty.NVL(data?.occupationCd) | technicalTranslate: 'occupationCd'}}</td>
        <td>{{ commonUtilty.NVL(data?.yearlyIncomeRangeCd) }}</td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>

<!-- Identity Details -->
<ng-container>
  <h3 class="heading heading-summary"> <i nz-icon nzType="idcard" class="m-r-5"></i>
    <span>Identity</span>
  </h3>
  <nz-table *ngIf="commonUtilty.hasDetails(selectedClient?.person?.personIdentities); else noDataTemplate" #identityTable nzSize="small" [nzData]="selectedClient?.person?.personIdentities" [nzShowPagination]="false"
    [nzBordered]="true">
    <thead>
      <tr>
        <th>Type</th>
        <th>Number</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of identityTable.data">
        <td>{{ commonUtilty.NVL(data?.identityTypeCd) | technicalTranslate: 'identityTypeCd' }}</td>
        <td>{{ commonUtilty.NVL(data?.identityNum) }}</td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>

<!-- Email -->
<ng-container>
  <h3 class="heading heading-summary"><i nz-icon nzType="mail" class="m-r-5"></i>
    <span>Email</span>
  </h3>
  <nz-table *ngIf="commonUtilty.hasDetails(selectedClient?.clientEmails); else noDataTemplate" #emailTable nzSize="small" [nzData]="selectedClient?.clientEmails" [nzShowPagination]="false"
    [nzBordered]="true">
    <thead>
      <tr>
        <th>Type</th>
        <th>Email</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of emailTable.data">
        <td>{{ commonUtilty.NVL(data?.typeCd) | technicalTranslate }}</td>
        <td>{{ commonUtilty.NVL(data?.emailId) }}</td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>


<!-- Contact Details -->
<ng-container>
  <h3 class="heading heading-summary"> <i nz-icon nzType="mobile" class="m-r-5"></i>
    <span>Contact No.</span>
  </h3>
  <nz-table *ngIf="commonUtilty.hasDetails(selectedClient?.clientContactDetails); else noDataTemplate" #contactDetails nzSize="small" [nzData]="selectedClient?.clientContactDetails" [nzShowPagination]="false"
    [nzBordered]="true">
    <thead>
      <tr>
        <th>Type</th>
        <th>Contact No.</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of contactDetails.data">
        <td>{{commonUtilty.NVL(data?.typeCd) | technicalTranslate }}</td>
        <td>
          {{ commonUtilty.formatContactNumber(data?.std, data?.contactNum) }}
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>

<!-- Address -->
<ng-container>
  <h3 class="heading heading-summary"> <i nz-icon nzType="environment" class="m-r-5"></i>
    <span>Address</span>
  </h3>
  <div *ngIf="commonUtilty.hasDetails(selectedClient?.clientAddresses); else noDataTemplate" class="summary-container">
    <div *ngFor="let data of selectedClient?.clientAddresses">
      <div>
        <span class="s-c-head">{{ commonUtilty.NVL(data?.typeCd) | technicalTranslate }}</span>
      </div>
      <div>
        <span class="address-width">
          {{ commonUtilty.NVL(data?.addressLine1) }}, {{ commonUtilty.NVL(data?.addressLine2) }},{{
          commonUtilty.NVL(data?.addressLine3) }} {{ commonUtilty.NVL(data?.cityCd) | technicalTranslate: 'cityCd'
          }}{{ commonUtilty.NVL(data?.countryCd) | technicalTranslate: 'countryCd' }},
          {{ commonUtilty.NVL(data?.postCode) }}
        </span>
      </div>
    </div>
  </div>
</ng-container>

<!-- No Data Template -->
<ng-template #noDataTemplate>
  <div class="icon-size">
    <i class="p-r-5" nz-icon nzType="inbox"></i>
    <span>No Data Available</span>
  </div>
</ng-template>